import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/layout'
import H5Layout from '@/views/H5/index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
  	{
      path: '/',
      component: Layout,
      redirect: '/base',
      name: 'Home'
    },
    
    /* 开发教程 start */
    {
      path: '/base',
      component: Layout,
      name: 'Base', //快速入门
      children: [
        {
          path: '',
          name: 'BaseIndex',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/base/index')
        }
      ]
    },
    {
      path: '/start',
      component: Layout,
      redirect: '/start/environment',
      name: 'Start', //起步
      children: [
        {
          path: 'environment',
          name: 'Environment',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/start/environment')
        },
        {
          path: 'develop',
          name: 'Develop',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/start/develop')
        },
        {
          path: 'debug',
          name: 'Debug',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/start/debug')
        }
      ]
    },
    {
      path: '/demo',
      component: Layout,
      redirect: '/demo/socket',
      name: 'Demo', //JOSH开发板
      children: [
        {
          path: 'socket',
          name: 'DemoSocket',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/demos/SocketDemo')
        },
        {
          path: 'uart',
          name: 'DemoUart',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/demos/UartDemo')
        },
        {
          path: 'file',
          name: 'DemoFile',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/demos/FileDemo')
        },
        {
          path: 'deviceInfo',
          name: 'DemoDeviceInfo',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/demos/DeviceInfoDemo')
        },
      ]
    },
    {
      path: '/device',
      component: Layout,
      redirect: '/device/expalin',
      name: 'Device', //JOSH开发板
      children: [
        {
          path: 'explain',
          name: 'DeviceExplain',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/device/explain')
        },
        {
          path: 'manual',
          name: 'DeviceManual',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/device/manual')
        }
      ]
    },
    {
      path: '/esp32',
      component: Layout,
      redirect: '/esp32/update',
      name: 'ESP32', //ESP32开发板
      children: [
        {
          path: 'update',
          name: 'ESP32Update',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/ESP32/fixedUpdate')
        },
        {
          path: 'develop',
          name: 'ESP32Develop',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/ESP32/appdevelop')
        }
      ]
    },
    {
      path: '/esp32/mini',
      component: Layout,
      redirect: '/esp32/mini/update',
      name: 'ESP32Mini', //ESP32开发板
      children: [
        {
          path: 'update',
          name: 'ESP32MiniUpdate',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/ESP32Mini/fixedUpdate')
        },
        {
          path: 'develop',
          name: 'ESP32MiniDevelop',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/ESP32Mini/appdevelop')
        }
      ]
    },
    {
      path: '/josh/megaesp32',
      component: Layout,
      redirect: '/josh/megaesp32/expalin',
      name: 'JoshESP', //JOSH乐鑫开发板
      children: [
        {
          path: 'expalin',
          name: 'MegaEspExplain',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/MEGAESP32/explain')
        },
        {
          path: 'manual',
          name: 'MegaEspManual',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/MEGAESP32/manual')
        }
      ]
    },
    {
      path: '/resource',
      component: Layout,
      redirect: '/resource/document',
      name: 'Resource', //资源中心
      children: [
        {
          path: 'index',
          name: 'ResourceIndex',
          meta: {
            parent: 'document'
          },
          component: () => import('@/views/document/resource/index')
        }
      ]
    },
    /* 开发教程 end */

    /* 开发者平台介绍 start */
    {
      path: '/develop/base',
      component: Layout,
      name: 'DevBase', //基础流程
      children: [
        {
          path: '',
          name: 'DevInfo',
          meta: {
            parent: 'develop'
          },
          component: () => import('@/views/develop/base/introduce')
        },
        {
          path: 'overview',
          name: 'DevOverview',
          meta: {
            parent: 'develop'
          },
          component: () => import('@/views/develop/base/overview')
        }
      ]
    },
    {
      path: '/develop/regist',
      component: Layout,
      name: 'DevRegist', //基础流程
      children: [
        {
          path: 'dev',
          name: 'RegistDev',
          meta: {
            parent: 'develop'
          },
          component: () => import('@/views/develop/regist/develop')
        },
        {
          path: 'business',
          name: 'BusRegist',
          meta: {
            parent: 'develop'
          },
          component: () => import('@/views/develop/regist/business')
        }
      ]
    },
    {
      path: '/develop/deviceManage',
      component: Layout,
      name: 'DeviceManage', //基础流程
      children: [
        {
          path: 'device',
          name: 'DeviceManageDevice',
          meta: {
            parent: 'develop'
          },
          component: () => import('@/views/develop/deviceManage/device')
        },
        {
          path: 'group',
          name: 'DeviceManageGroup',
          meta: {
            parent: 'develop'
          },
          component: () => import('@/views/develop/deviceManage/group')
        },
        {
          path: 'task',
          name: 'DeviceManageTask',
          meta: {
            parent: 'develop'
          },
          component: () => import('@/views/develop/deviceManage/task')
        }
      ]
    },
    {
      path: '/develop/appManage',
      component: Layout,
      name: 'AppManage', //基础流程
      children: [
        {
          path: '',
          name: 'DevelopAppManage',
          meta: {
            parent: 'develop'
          },
          component: () => import('@/views/develop/appManage/app')
        }
      ]
    },
    {
      path: '/develop/user',
      component: Layout,
      name: 'UserManage', //基础流程
      children: [
        {
          path: '',
          name: 'DevelopUserManage',
          meta: {
            parent: 'develop'
          },
          component: () => import('@/views/develop/user/user')
        }
      ]
    },
    /* 开发者平台介绍 end */

    /* H5教程 start */
    {
      path: '/h5',
      component: H5Layout,
      name: 'H5Document',
      children: [
        {
          path: '',
          name: 'H5Dashboard',
          redirect: '/megaesp32',
          // component: () => import('@/views/H5/dashboard')
        },
        {
          path: '/megaesp32',
          name: 'H5-MEGAESP32',
          component: () => import('@/views/H5/megaesp32')
        }
      ]
    },
    /* H5教程 start */
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js